export const RELEASE = {
    version: 'ciranet-ui@25.5.1.2-production'
};
